module.exports = __webpack_public_path__ + "static/poor-charlies-almanack-3f9033ad452229703ee723c7a4e02e7d.jpg";